const Checklist = {

    // FIELDS
    "premise": "Premise",
    "name": "Name",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "checklist": "Checklist",

    // ERROR
    "error_premise": "Select Premise",
    "error_name": "Enter Name",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_premise": 'PREMISE',
    "table_name": 'NAME',
    "table_status": "STATUS",

}

export default Checklist;